import { Component, OnInit } from '@angular/core';
import { DestroySubscriberComponent } from '@b3networks/shared/common';
import { ThemeService } from '@b3networks/shared/ui/theme';

@Component({
  selector: 'b3n-remote-support-home',
  templateUrl: './remote-support-home.component.html',
  styleUrls: ['./remote-support-home.component.scss']
})
export class RemoteSupportHomeComponent extends DestroySubscriberComponent implements OnInit {
  isDarkMode$ = this.themeService.isDarkMode$;

  ngOnInit(): void {}

  constructor(private themeService: ThemeService) {
    super();
  }
}
